/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Remind_Sms_FromInputs */

const en_portal_remind_sms_from = /** @type {(inputs: Portal_Remind_Sms_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete Athlete`)
};

const pl_portal_remind_sms_from = /** @type {(inputs: Portal_Remind_Sms_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete Athlete`)
};

/**
* | output |
* | --- |
* | "Complete Athlete" |
*
* @param {Portal_Remind_Sms_FromInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_remind_sms_from = /** @type {((inputs?: Portal_Remind_Sms_FromInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Remind_Sms_FromInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_remind_sms_from(inputs)
	return en_portal_remind_sms_from(inputs)
});